import styled from '@mui/system/styled'
import moment from 'moment'
import { rgba } from 'polished'

import logError from 'utils/errorLogger'

import { theme } from 'styles/theme'

const getStyle = (status: string, dueDate?: string) => {
  const today = moment().startOf('day').format('YYYY-MM-DD')
  switch (status) {
    case 'pending':
      if (dueDate && moment(dueDate).isBefore(today)) {
        return {
          color: theme.palette.alert[300],
          background: rgba(theme.palette.alert[400], 0.3)
        }
      }
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'processing':
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'active':
      return {
        color: theme.palette.primary[100],
        background: rgba(theme.palette.primary.main, 0.1)
      }
    case 'created_payment':
      return {
        color: theme.palette.neutral[700],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'open_payment':
      if (dueDate && moment(dueDate).isBefore(today)) {
        return {
          color: theme.palette.alert[300],
          background: rgba(theme.palette.alert[400], 0.3)
        }
      }
      return {
        color: theme.palette.secondary[200],
        background: rgba(theme.palette.secondary[200], 0.2)
      }
    case 'no_payment':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'expiring':
      return {
        color: theme.palette.alert[300],
        background: rgba(theme.palette.alert[400], 0.3)
      }
    case 'paid':
    case 'received':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'partial_paid':
    case 'partially_received':
      return {
        color: theme.palette.secondary[200],
        background: rgba(theme.palette.secondary[200], 0.1)
      }
    case 'matched_suggestion':
      return {
        color: theme.palette.secondary[200],
        background: rgba(theme.palette.secondary[200], 0.1)
      }
    case 'reconciled':
    case 'created_entry':
    case 'settled_entry':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'ignored':
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'confirmada':
    case 'confirmed':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'cancelling':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'canceled':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'cancelled':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'with_error':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'expired':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'finished':
    case 'completed':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.1)
      }
    case 'ready_for_review':
      return {
        color: theme.palette.alert[300],
        background: rgba(theme.palette.alert[400], 0.3)
      }
    case 'partially_reconciled':
      return {
        color: theme.palette.secondary[200],
        background: rgba(theme.palette.secondary[200], 0.1)
      }
    case 'issued':
      return {
        color: theme.palette.primary[300],
        background: rgba(theme.palette.primary[300], 0.3)
      }

    case 'suspended':
      return {
        color: theme.palette.neutral[700],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'succeeded':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'failed':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'partially_failed':
      return {
        color: theme.palette.alert[300],
        background: rgba(theme.palette.alert[400], 0.3)
      }
    case 'under_analysis':
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'blocked':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'deleted':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'archived':
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
    case 'client':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'billing':
      return {
        color: theme.palette.primary.main,
        background: rgba(theme.palette.secondary[200], 0.2)
      }
    case 'open':
      return {
        color: theme.palette.secondary[200],
        background: rgba(theme.palette.secondary[200], 0.1)
      }
    case 'overdue':
      return {
        color: theme.palette.alert[300],
        background: rgba(theme.palette.alert[400], 0.3)
      }
    // Usuário do merchant convidado que ainda não ativou o acesso. Amarelo de
    // espera, não o cinza do `pending` de cobrança.
    case 'user_pending':
      return {
        color: theme.palette.alert[300],
        background: rgba(theme.palette.alert[400], 0.3)
      }
    // Usuário do merchant desativado (Configurações › Usuários).
    case 'disabled':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    case 'bank_account_active':
      return {
        color: theme.palette.primary[200],
        background: rgba(theme.palette.primary[200], 0.2)
      }
    case 'bank_account_inactive':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    // SC-10832: conta criada que ainda não foi confirmada por código. Não
    // recebe saque até a confirmação, então é um estado de espera, não de erro.
    case 'bank_account_pending':
      return {
        color: theme.palette.alert[300],
        background: rgba(theme.palette.alert[400], 0.3)
      }
    // Status de sincronização com o Conta Azul
    case 'synced':
      return {
        color: theme.palette.success[300],
        background: rgba(theme.palette.success[300], 0.12)
      }
    case 'syncing':
    case 'enqueued':
      return {
        color: theme.palette.info[300],
        background: rgba(theme.palette.info[300], 0.12)
      }
    case 'error':
      return {
        color: theme.palette.error[300],
        background: rgba(theme.palette.error[300], 0.1)
      }
    default:
      logError(
        `Erro ao mapear estilos da Status: ${status} (Status/status.styles)`
      )
      return {
        color: theme.palette.neutral[400],
        background: rgba(theme.palette.neutral[700], 0.3)
      }
  }
}

type StatusProps = {
  status: string
  fontIsThini?: boolean
  dueDate?: string
}

// Função para mapear status completo (cor, fontColor e label) - compatível com installments table
export const getStatusComplete = (
  status: string,
  dueDate?: string,
  masculine?: boolean
) => {
  const style = getStyle(status, dueDate)
  const label = getStatusLabel(status, dueDate, masculine)

  return {
    color: style.background,
    fontColor: style.color,
    label,
    fontWeight: '600'
  }
}

// Função para mapear labels dos status
export const getStatusLabel = (
  status: string,
  dueDate?: string,
  masculine?: boolean
) => {
  const today = moment().startOf('day').format('YYYY-MM-DD')

  // Função auxiliar para aplicar gênero aos status que terminam em a/o
  const applyGender = (feminine: string, masculineForm: string) => {
    return masculine ? masculineForm : feminine
  }

  switch (status) {
    case 'pending':
      if (dueDate && moment(dueDate).isBefore(today)) {
        return applyGender('Atrasada', 'Atrasado')
      }
      return 'Pendente'
    case 'processing':
      return 'Processando'
    case 'active':
      return masculine ? 'Ativo' : 'Ativa'
    case 'created_payment':
      return 'Pendente'
    case 'open_payment':
      if (dueDate && moment(dueDate).isBefore(today)) {
        return applyGender('Atrasada', 'Atrasado')
      }
      return applyGender('Aberta', 'Aberto')
    case 'open':
      return applyGender('Aberta', 'Aberto')
    case 'no_payment':
      return applyGender('Expirada', 'Expirado')
    case 'paid':
      return applyGender('Paga', 'Pago')
    case 'received':
      return applyGender('Recebida', 'Recebido')
    case 'partial_paid':
      return 'Parcialmente Pago'
    case 'partially_received':
      return applyGender('Parcialmente Recebida', 'Parcialmente Recebido')
    case 'matched_suggestion':
      // "Match" é o nome do motor, não do que o usuário faz: na tela a ação é conciliar.
      return 'Sugestão'
    case 'reconciled':
      return 'Conciliada'
    case 'created_entry':
      return 'Lançamento criado'
    case 'settled_entry':
      // Concorda com TRANSAÇÃO, como os vizinhos "Conciliada" e "Ignorada" — o chip é da
      // transação do extrato, não do lançamento que ela liquidou.
      return 'Baixada'
    case 'ignored':
      return 'Ignorada'
    case 'confirmada':
      return applyGender('Confirmada', 'Confirmado')
    case 'cancelling':
      return applyGender('Cancelada', 'Cancelado')
    case 'canceled':
      return applyGender('Cancelada', 'Cancelado')
    case 'cancelled':
      return applyGender('Cancelada', 'Cancelado')
    case 'with_error':
      return 'Com erro'
    case 'expired':
      return applyGender('Expirada', 'Expirado')
    case 'finished':
      return applyGender('Finalizada', 'Finalizado')
    case 'completed':
      return applyGender('Concluída', 'Concluído')
    case 'ready_for_review':
      return 'Pronto para revisão'
    case 'partially_reconciled':
      return 'Parcial'
    case 'suspended':
      return applyGender('Suspensa', 'Suspenso')
    case 'succeeded':
      return 'Sucesso'
    case 'failed':
      return applyGender('Falhada', 'Falhado')
    case 'partially_failed':
      return 'Falha parcial'
    case 'under_analysis':
      return 'Em análise'
    case 'blocked':
      return applyGender('Bloqueada', 'Bloqueado')
    case 'deleted':
      return applyGender('Excluída', 'Excluído')
    case 'archived':
      return applyGender('Arquivada', 'Arquivado')
    case 'client':
      return 'Cliente'
    case 'billing':
      return 'Cobrança'
    case 'overdue':
      return applyGender('Atrasada', 'Atrasado')
    case 'user_pending':
      return 'Pendente'
    case 'disabled':
      return applyGender('Desativada', 'Desativado')
    case 'bank_account_active':
      return 'Ativa'
    case 'bank_account_inactive':
      return 'Inativa'
    case 'bank_account_pending':
      return 'Aguardando confirmação'
    // Status de sincronização com o Conta Azul
    case 'synced':
      return 'Sincronizado'
    case 'syncing':
    case 'enqueued':
      return 'Sincronizando'
    case 'error':
      return 'Erro'
    default:
      return 'Status desconhecido'
  }
}

/**
 * Geometria ÚNICA dos chips de status/tipo do sistema — nunca valores soltos. Existiam
 * ~30 clones com fontSize divergente (de 10px a 14px, vários sem fontSize nenhum), e dois
 * chips na MESMA LINHA saíam de tamanhos diferentes.
 *
 * `fontSize` sai de `--cb-table-font-size` (components/Table/tableDisplay.ts): resolve
 * pra 14px em todo lugar e cresce junto quando o usuário aumenta a fonte da tabela. O
 * padding em `em` escala junto pelo mesmo motivo. `lineHeight` é explícito porque sem ele
 * a altura variava com o contexto; 1.3 × 14px + 8px = 26px, a mesma altura do `Chip` da
 * library, pra que os dois fiquem alinhados na mesma linha.
 *
 * Chip novo? Use `Status`, `CellChip` (features/table-columns/cells.tsx) ou espalhe este
 * token. NÃO copie os valores.
 */
export const statusChipBase = {
  boxSizing: 'border-box' as const,
  display: 'inline-block',
  width: 'fit-content',
  padding: '0.2857em 0.5714em',
  fontSize: 'var(--cb-table-font-size, 14px)',
  fontWeight: 600,
  lineHeight: 1.3,
  borderRadius: 9999,
  whiteSpace: 'nowrap' as const
}

export const Status = styled('div')<StatusProps>(
  ({ status, fontIsThini, dueDate }) => ({
    ...statusChipBase,
    ...getStyle(status, dueDate),
    ...(fontIsThini && {
      fontWeight: 400,
      padding: '0.1428em 0.7142em' // 2px/10px @14px, em pra escalar junto
    })
  })
)
